import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Keep UI choices on this history entry so Back restores them. No global cache,
// storage, quiz data or invitation drafts; navigating away creates a new entry.
export default function usePageChoice(key, fallback, enabled = true) {
  const history = useHistory();
  const [route] = useState(() => history && history.location.pathname + history.location.search);
  const [value, setValue] = useState(() => history?.location?.state?.mentorshipChoices?.[key] ?? fallback);
  useEffect(() => {
    if (!enabled || !history || history.location.pathname + history.location.search !== route) return;
    const location = history.location;
    history.replace({ ...location, state: { ...location.state,
      mentorshipChoices: { ...location.state?.mentorshipChoices, [key]: value },
    } });
  }, [history, route, key, value, enabled]);
  return [value, setValue];
}

export const studentProgressLocation = (studentId, returnState) => ({
  pathname: `/mentorships/students/${studentId}`,
  state: { mentorshipReturnState: returnState },
});
